export const CREATE_CANDIDATE_USER = "CREATE_CANDIDATE_USER";
export const CREATE_CANDIDATE_USER_SUCCESS = "CREATE_CANDIDATE_USER_SUCCESS";
export const CREATE_CANDIDATE_USER_FAILURE = "CREATE_CANDIDATE_USER_FAILURE";

export const FETCH_CANDIDATE_BY_EMAIL = "FETCH_CANDIDATE_BY_EMAIL";
export const FETCH_CANDIDATE_BY_EMAIL_SUCCESS =
  "FETCH_CANDIDATE_BY_EMAIL_SUCCESS";
export const FETCH_CANDIDATE_BY_EMAIL_FAILURE =
  "FETCH_CANDIDATE_BY_EMAIL_FAILURE";
